import { defineMessages } from 'react-intl';

export default defineMessages({
    bankAccNumMandatoryTitle: {
        id: 'sasria.bankservices.bankAccNumMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankAccNumMandatoryMessage: {
        id: 'sasria.bankservices.bankAccNumMandatoryMessage.',
        defaultMessage: 'Bank Account Number is mandatory'
    },

    bankCodeNumMandatoryTitle: {
        id: 'sasria.bankservices.bankCodeNumMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankCodeNumMandatoryMessage: {
        id: 'sasria.bankservices.bankCodeNumMandatoryMessage.',
        defaultMessage: 'Branch Code is mandatory'
    },

    bankAccTypeMandatoryTitle: {
        id: 'sasria.bankservices.bankAccTypeMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankAccTypeMandatoryMessage: {
        id: 'sasria.bankservices.bankAccTypeMandatoryMessage.',
        defaultMessage: 'Account Type is mandatory'
    }, 

    insuredamountFieldMandatoryTitle: {
        id: 'sasria.bankservices.insuredamountFieldMandatoryTitle',
        defaultMessage: 'Error'
    },
    insuredamountFieldMandatoryMessage: {
        id: 'sasria.bankservices.insuredamountFieldMandatoryMessage.',
        defaultMessage: 'Amount is mandatory and should be greater than 0'
    },

    agentamountFieldMandatoryTitle: {
        id: 'sasria.bankservices.agentamountFieldMandatoryTitle',
        defaultMessage: 'Error'
    },
    agentamountFieldMandatoryMessage: {
        id: 'sasria.bankservices.agentamountFieldMandatoryMessage.',
        defaultMessage: 'Amount is mandatory and should be greater than 0'
    },


    bankNameMandatoryTitle: {
        id: 'sasria.bankservices.bankNameMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankNameMandatoryMessage: {
        id: 'sasria.bankservices.bankNameMandatoryMessage.',
        defaultMessage: 'Bank Name is mandatory'
    },

    AVSValidationTitle: {
        id: 'sasria.bankservices.AVSValidationTitle',
        defaultMessage: 'Bank data cannot be saved'
    },
    AVSValidationMessage: {
        id: 'sasria.bankservices.AVSValidationMessage.',
        defaultMessage: 'Registration Number is mandatory for Vendor Company and Passport or Identity Number is mandatory for Vendor Contact.'
    },

    invalidBankTitle: {
        id: 'sasria.bankservices.invalidBankTitle',
        defaultMessage: 'Account number is invalid'
    },

    invalidBankMessage: {
        id: 'sasria.bankservices.invalidBankMessage',
        defaultMessage: 'Account Number should be a number up to 13 digits long, with no spaces.'
    },

    documentUploadFailed: {
        id: 'sasria.bankservices.Document Upload failed',
        defaultMessage: 'DocumentUploadFailed'
    },
    documentCannotBeUploaded: {
        id: 'sasria.bankservices.component.document-component.Sorry your document could not be uploaded at this time',
        defaultMessage: 'Sorry your document could not be uploaded at this time'
    },

    canAddOneInsuredBankAccntTitle: {
        id: 'sasria.bankservices.canAddOneInsuredBankAccntTitle',
        defaultMessage: 'Error : Attempting to add more than one Insured bank account'
    },
    canAddOneInsuredBankAccntMessage: {
        id: 'sasria.bankservices.canAddOneInsuredBankAccntMessage',
        defaultMessage: 'Payment can be made with only one Insured Bank Account'
    },

    canAddOneAgentBankTitle: {
        id: 'sasria.bankservicescanAddOneAgentBankTitle',
        defaultMessage: 'Error : Attempting to add more than one Agent bank account'
    },
    canAddOneAgentBankMessage: {
        id: 'sasria.bankservices.canAddOneAgentBankMessage',
        defaultMessage: 'Payment can be made with only one Agent Bank Account'
    },

    checkIfExistingInsuredBankTitle: {
        id: 'sasria.checkIfExistingInsuredBanTitle',
        defaultMessage: 'Duplicate Bank Account Error : The input bank details match with one of the existing bank account of Insured'
    },
    checkIfExistingInsuredBankMessage: {
        id: 'sasria.bankservices.checkIfExistingInsuredBankMessage',
        defaultMessage: 'Please select from dropdown if you want to add an existing bank account'
    },

    duplicateInsuredBankCardTitle: {
        id: 'sasria.duplicateInsuredBankCardTitle',
        defaultMessage: 'Duplicate Insured Bank Error'
    },
    duplicateInsuredBankCardMessage: {
        id: 'sasria.bankservices.duplicateInsuredBankCardMessage',
        defaultMessage: 'This Bank Account Details are already added in Insured Bank Card.'
    },

    duplicateAgentBankCardTitle: {
        id: 'sasria.duplicateAgentBankCardTitle',
        defaultMessage: 'Duplicate Agent Bank Error'
    },
    duplicateAgentBankCardMessage: {
        id: 'sasria.bankservices.duplicateAgentBankCardMessage',
        defaultMessage: 'This Bank Account Details are already added in Agent Bank Card.'
    },
    bankDocumentMandatoryTitle: {
        id: 'sasria.bankDocumentMandatoryTitle',
        defaultMessage: 'Error'
    },
    bankDocumentMandatoryMessage: {
        id: 'sasria.bankservices.bankDocumentMandatoryMessage',
        defaultMessage: 'Supporting Bank Document needs to be uploaded.'
    },
    reimbursementSelectionValidationTitle: {
        id: 'sasria.reimbursementSelectionValidationTitle',
        defaultMessage: 'Error - Cannot make payment from Agent Bank when Reimbursement is selected as No'
    },
    reimbursementSelectionValidationMessage: {
        id: 'sasria.bankservices.reimbursementSelectionValidationMessage',
        defaultMessage: 'Please select Reimbursement Radio Button as Yes if you want to make  payment from Agent Bank Account.'
    },
    paymentDocumentMandatoryTitle: {
        id: 'sasria.paymentDocumentMandatoryTitle',
        defaultMessage: 'Error - Proof Of Payment document not uploaded'
    },
    paymentDocumentMandatoryMessage: {
        id: 'sasria.bankservices.paymentDocumentMandatoryMessage',
        defaultMessage: 'Supporting Proof Of Payment documents needs to be uploaded if Reimbursement is selected as Yes.'
    },
    paymentAmountNotMatchingTitle: {
        id: 'sasria.paymentAmountNotMatchingTitle',
        defaultMessage: 'Error'
    },
    paymentAmountNotMatchingMessage: {
        id: 'sasria.bankservices.paymentAmountNotMatchingMessage',
        defaultMessage: 'Payment Amount field value not matching with Total Final Loss Estimate.'
    }

});
